import resume from '../assets/pdf/resume.pdf'

export const headerData = {
    name: 'Rakesh Ganesula',
    title: "Software Developer",
    desciption:"I am a final year undergrad, pursuing B-Tech in CSE from the Indian Institute of Information technology, Sri city. I am a Software Developer with interest in Data Structures and Algorithms and Competitive Programming. I am skilled in C++, Java, Python, and Databases. I am also very interested in Web Development, and AI/ML. I always have a great passion for learning new technological aspects and exploring many fields.",
    image: 'https://res.cloudinary.com/ddtynlkwv/image/upload/v1665341205/IMG_20220420_122937_ajke7l.jpg',
    resumePdf: resume
}
